import React from 'react';
import { Table, Tabs, Collapse } from 'antd';

const FilePreview = ({ inspection }) => {
    if (!inspection) return null;
    if (inspection.error) {
        return <div style={{ color: 'var(--red-color)', padding: 8 }}>{inspection.error}</div>;
    }

    const sheets = inspection.sheets || [];
    if (sheets.length === 0) return null;

    const renderSheet = (sheet) => {
        const columns = (sheet.columns || []).map((col) => ({
            title: String(col),
            dataIndex: String(col),
            key: String(col),
            ellipsis: true,
            width: 140,
        }));

        return (
            <div>
                <div style={{ fontSize: 12, color: 'var(--medium-light-grey-color)', marginBottom: 6 }}>
                    {sheet.row_count != null && <span>{sheet.row_count.toLocaleString()} rows</span>}
                    {sheet.columns && <span> &middot; {sheet.columns.length} columns</span>}
                    {sheet.date_columns && Object.keys(sheet.date_columns).length > 0 && (
                        <span> &middot; Dates: {Object.entries(sheet.date_columns).map(([col, range]) =>
                            `${col} (${range.min} to ${range.max})`
                        ).join(', ')}</span>
                    )}
                </div>
                <Table
                    dataSource={(sheet.preview || []).map((row, i) => ({ ...row, _key: i }))}
                    columns={columns}
                    rowKey="_key"
                    pagination={false}
                    size="small"
                    scroll={{ x: 'max-content' }}
                    style={{ fontSize: 12 }}
                />
            </div>
        );
    };

    if (sheets.length === 1) {
        return (
            <Collapse size="small" style={{ marginTop: 8 }}>
                <Collapse.Panel header={`Preview: ${inspection.file_name}`} key="1">
                    {renderSheet(sheets[0])}
                </Collapse.Panel>
            </Collapse>
        );
    }

    return (
        <Collapse size="small" style={{ marginTop: 8 }}>
            <Collapse.Panel header={`Preview: ${inspection.file_name} (${sheets.length} sheets)`} key="1">
                <Tabs
                    size="small"
                    items={sheets.map((sheet) => ({
                        key: sheet.sheet_name,
                        label: sheet.sheet_name,
                        children: renderSheet(sheet),
                    }))}
                />
            </Collapse.Panel>
        </Collapse>
    );
};

export default FilePreview;
